import { Auth } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getUserAuthenticationHookDetails } from "../../services/AuthService";
import BackendService from "../../services/BackendService";
import {
  deleteUnConfirmedUser,
  getUserInvitationDetails,
} from "../../services/UserService";
import LoadingSpinner from "../../utils/components/common/loadingSpinner/LoadingSpinner";
import { useEffectOnce } from "../../utils/utils";
import "./Auth.scss";
import LeftPanel from "./LeftPanel";

const initialSignUpData = {
  name: "",
  password: "",
  email: "",
  phone_number: "",
  confirmpassword: "",
};

const SignUp = () => {
  const emailReg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  const mobileReg = /^(\+\d{1,3}[-]?)?\d{10}$/;
  const nameReg = /^[ A-Za-z0-9-]{1,64}$/;
  const passReg =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{8,}$/;
  const navigate = useNavigate();
  const location = useLocation();
  const signupParam = useParams();
  const [formData, updateFormData] = useState(initialSignUpData);
  const [tenantName, setTenantName] = useState("");
  const [viewPass, setViewPass] = useState(true);
  const [viewConfirmPass, setViewConfirmPass] = useState(true);
  const [nextDisable, setNextDisable] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [inviteLinkExpired, setInviteLinkExpired] = useState(false);
  const [validation, setValidation] = useState({
    nameInvalid: false,
    mobileEmpty: false,
    mobileInvalid: false,
    emailInvalid: false,
    passwordInvalid: false,
    passwordLength: false,
    confirmPasswordInvalid: false,
    emailUsed: false,
    phoneUsed: false,
    securityErrors: "",
  });
  const { t } = useTranslation("auth");

  const signValidation = async () => {
    setValidation((validation) => ({
      ...validation,
      securityErrors: "",
    }));
    const { name, password, confirmpassword, phone_number, email } = formData;
    let validationError = false;
    let final_name = name;
    final_name = final_name.replace(/^\s+|\s+$/gm, ""); // replace leading and trailing spaces
    if (!nameReg.test(final_name)) {
      setValidation((validation) => ({
        ...validation,
        nameInvalid: true,
      }));
      validationError = true;
    }
    if (phone_number.length === 0) {
      setValidation((validation) => ({
        ...validation,
        mobileEmpty: true,
      }));
      validationError = true;
    }
    if (!mobileReg.test(phone_number)) {
      setValidation((validation) => ({
        ...validation,
        mobileInvalid: true,
      }));
      validationError = true;
    }

    //To Extract the first 3 digits to check for +91
    const firstThreeDigits = phone_number.substring(0, 3);

    if (firstThreeDigits === "+91" && phone_number.length !== 13) {
      setValidation({
        ...validation,
        mobileInvalid: true,
        mobileEmpty: false,
        phoneUsed: false,
      });
      return;
    }

    let final_phone_number = phone_number;
    final_phone_number = final_phone_number.replace(/-/g, ""); // remove - as cognito doesnt accept it.

    if (!emailReg.test(email)) {
      setValidation((validation) => ({
        ...validation,
        emailInvalid: true,
      }));
      validationError = true;
    }
    if (!passReg.test(password)) {
      setValidation((validation) => ({
        ...validation,
        passwordInvalid: true,
      }));
      validationError = true;
    }

    if (password !== confirmpassword) {
      setValidation((validation) => ({
        ...validation,
        confirmPasswordInvalid: true,
      }));
      validationError = true;
    }
    setIsSubmitted(true);
    const checkUserEmailResp = await checkUser("email", email);
    const checkUserPhoneResp = await checkUser(
      "phone_number",
      final_phone_number
    );

    if (checkUserEmailResp) {
      setValidation((validation) => ({ ...validation, emailUsed: true }));
      validationError = true;
    }

    if (checkUserPhoneResp) {
      setValidation((validation) => ({ ...validation, phoneUsed: true }));
      validationError = true;
    }

    if (!validationError) {
      signUp(formData);
    } else {
      setIsSubmitted(false);
      updateFormData(() => ({
        ...formData,
        password: "",
        confirmpassword: "",
      }));
    }
  };
  const checkUser = async (attr, attrValue) => {
    try {
      const param = {
        attribute: attr,
        attribute_value: attrValue,
        action: "GetUserAttribute",
      };
      const resp = await getUserAuthenticationHookDetails(param);
      if (resp.data && resp.data.Users.length > 0) {
        const attribute = resp.data.Users[0].Attributes.find(
          (elem) => elem.Name === attr
        );
        return attribute ? true : false;
      } else {
        return false;
      }
    } catch (err) {}
  };
  const signUp = async (data) => {
    setIsSubmitted(true);
    try {
      const { name, password, phone_number, email } = data;
      let final_name = name;
      final_name = final_name.replace(/^\s+|\s+$/gm, ""); // replace leading and trailing spaces
      let final_phone_number = phone_number;
      final_phone_number = final_phone_number.replace(/-/g, ""); // remove - as cognito doesnt accept it.
      await Auth.signUp({
        username: final_phone_number,
        password,
        attributes: {
          email,
          phone_number: final_phone_number,
          name: final_name,
        },
      });
      setIsSubmitted(false);
      localStorage.setItem("unconfirmed_email", email);
      navigate("/confirmmobile", {
        state: {
          phone_number: final_phone_number,
          email: formData.email,
          name: formData.name,
          password: formData.password,
          confirmpassword: formData.confirmpassword,
          inviteid: signupParam?.id,
        },
      });
    } catch (error) {
      setIsSubmitted(false);
      const { message } = error;
      if (message === "Invalid phone number format.") {
        setValidation({ ...validation, mobileInvalid: true });
      } else {
        setValidation({ ...validation, securityErrors: message });
      }
      updateFormData(() => ({
        ...formData,
        password: "",
        confirmpassword: "",
      }));
    }
  };

  const handleMobile = (phone) => {
    let final_phone;

    if (phone.length > 0) final_phone = "+" + phone;
    else final_phone = phone;

    setValidation({
      ...validation,
      mobileEmpty: false,
      mobileInvalid: false,
      phoneUsed: false,
    });

    updateFormData(() => ({ ...formData, ["phone_number"]: final_phone }));
  };

  const onChange = (e) => {
    e.persist();
    if (e.target.name === "name") {
      setValidation({ ...validation, nameInvalid: false });
    }
    if (e.target.name === "email") {
      if (e.target.value.includes(" ")) {
        e.target.value = e.target.value.replace(/\s/g, "");
      }
      setValidation({
        ...validation,
        emailInvalid: false,
        emailUsed: false,
      });
    }
    if (e.target.name === "password") {
      setValidation({
        ...validation,
        passwordInvalid: false,
        passwordLength: false,
      });
    }
    if (e.target.name === "confirmpassword") {
      setValidation({ ...validation, confirmPasswordInvalid: false });
    }

    updateFormData(() => ({
      ...formData,
      [e.target.name]: e.target.value,
    }));
  };
  const viewPassword = () => {
    setViewPass(!viewPass);
  };
  const viewConfirmPassword = () => {
    setViewConfirmPass(!viewConfirmPass);
  };

  const handleKeypress = (e) => {
    if (e.key === "Enter") {
      if (!nextDisable) signValidation();
    }
  };

  const getBackendConfig = () => {
    const { email } = formData;
    BackendService.getConfig(email);
  };

  const checkUnconfirmedEmail = () => {
    const unconfirmed_email = localStorage.getItem("unconfirmed_email");

    if (unconfirmed_email) {
      const param = {
        attribute: "email",
        attribute_value: unconfirmed_email,
      };
      deleteUnConfirmedUser(param)
        .then((response) => {
          if (response.status === 200) {
            localStorage.removeItem("unconfirmed_email");
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    }
  };

  const getSignUpInvitationDetails = (Id) => {
    const param = {
      inviteId: Id,
    };
    getUserInvitationDetails(param)
      .then((response) => {
        if (response.status === 200) {
          updateFormData(() => ({
            ...formData,
            name: location?.state?.name,
            password: location?.state?.password,
            email: response?.data?.email,
            phone_number: location?.state?.phone_number,
            confirmpassword: location?.state?.confirmpassword,
          }));

          setTenantName(response?.data?.tenantName);
        } else {
          setInviteLinkExpired(true);
        }
      })
      .catch((err) => {
        setInviteLinkExpired(true);
        // console.log(err);
      });
  };

  useEffect(() => {
    if (
      formData.name &&
      formData.password &&
      formData.email &&
      formData.phone_number &&
      formData.confirmpassword
    ) {
      setNextDisable(false);
    } else {
      setNextDisable(true);
    }
  }, [formData]);

  useEffect(() => {
    if (location?.state) {
      updateFormData(() => ({
        ...formData,
        name: location?.state?.name,
        password: "",
        email: location?.state?.email,
        phone_number: location?.state?.phone_number,
        confirmpassword: "",
      }));
    }
  }, [location.state]);

  useEffectOnce(() => {
    checkUnconfirmedEmail();
  });

  useEffect(() => {
    if (signupParam?.id) {
      getSignUpInvitationDetails(signupParam?.id);
    }
  }, [signupParam]);

  return (
    <>
      <section className="authContainer">
        <LeftPanel />
        <div className="rightPanel">
          <img
            id="logo"
            src={require("../../assets/images/chorus-rgb.png")}
            className="img-fluid logo mb-4"
            alt="chorus"
          />
          {signupParam?.id ? (
            inviteLinkExpired ? (
              <div className="container-fluid tenantDetail d-flex flex-row justify-content-center mb-4 text-center align-items-center">
                <div className="validationError">
                  {t("invitationLinkExpired")}
                </div>
              </div>
            ) : (
              <div className="container-fluid tenantDetail d-flex flex-row justify-content-center mb-4 text-center align-items-center">
                <div id="already-account-text">
                  {t("createYourAccount")}{" "}
                  <span className="deviceTitle">{tenantName}</span>
                </div>
              </div>
            )
          ) : (
            <div className="container-fluid d-flex flex-row justify-content-end mb-4 align-items-center">
              <div id="already-account-text">Already have an account?</div>
              <button
                onClick={() => navigate("/signin")}
                id="signin"
                name="signin"
                className="linkBtn"
              >
                Login
              </button>
            </div>
          )}
          <div className="container-fluid flex-fill" onKeyDown={handleKeypress}>
            <div className="fieldset mb-4">
              <label id="name_label">{t("fullName")}</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  placeholder={t("namePlaceholder")}
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  name="name"
                  maxLength="64"
                  value={formData.name}
                  onChange={onChange}
                />
              </div>
              {validation.nameInvalid && (
                <span id="name_error" className="validationError">
                  {t("invalidNameErr")}
                </span>
              )}
            </div>
            <div className="fieldset mb-4">
              <label id="mobile_label">{t("mobNum")}</label>
              <div className="input-group">
                {/* <input type="tel" className="form-control" id="phonenumber" placeholder="Enter your mobile number" aria-label="Username" aria-describedby="basic-addon1" name="phone_number" maxLength="64"  onChange={onChange} /> */}
                <PhoneInput
                  country={"us"}
                  placeholder={t("mobNumlPlaceholder")}
                  onChange={handleMobile}
                  value={formData.phone_number}
                  className="phone-input"
                />
              </div>
              {(validation.mobileEmpty || validation.mobileInvalid) && (
                <span id="mobile_error1" className="validationError">
                  {t("invalidMobNumErr")}
                </span>
              )}
              {validation.phoneUsed && (
                <span id="mobile_error2" className="validationError">
                  {t("mobNumAlreadyRegErr")}
                </span>
              )}
            </div>
            <div className="fieldset mb-4">
              <label id="email_label">{t("emailId")}</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  id="email"
                  placeholder={t("emailPlaceholder")}
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  name="email"
                  maxLength="64"
                  value={formData.email}
                  onChange={onChange}
                  onBlur={getBackendConfig}
                  readOnly={signupParam?.id}
                />
              </div>
              {validation.emailInvalid && (
                <span id="email_error1" className="validationError">
                  {t("invalidEmail")}
                </span>
              )}
              {validation.emailUsed && (
                <span id="email_error2" className="validationError">
                  {t("emailAlreadyRegErr")}
                </span>
              )}
            </div>
            <div className="fieldset mb-4">
              <label id="pass_label">{t("password")}</label>
              <div className="input-group">
                <input
                  type={viewPass ? "password" : "text"}
                  id="password"
                  className="form-control"
                  value={formData.password}
                  placeholder={t("passPlaceholder")}
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  name="password"
                  maxLength="64"
                  onChange={onChange}
                />
                <span
                  className="input-group-text"
                  id="viewpass"
                  onClick={viewPassword}
                >
                  {!viewPass && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#7159A5"
                      className="bi bi-eye"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                    </svg>
                  )}
                  {viewPass && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#7159A5"
                      className="bi bi-eye-slash"
                      viewBox="0 0 16 16"
                    >
                      <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                      <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                      <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                    </svg>
                  )}
                </span>
              </div>
              {validation.passwordInvalid && (
                <span id="pass_error1" className="validationError">
                  Password field must be at least 8 characters and contain at
                  least one capital letter, one small letter, one number, and
                  one special character from: @$!%*?&_
                </span>
              )}
              {validation.passwordLength && (
                <span id="pass_error2" className="validationError">
                  {t("passLengthErr")}
                </span>
              )}
            </div>
            <div className="fieldset mb-4">
              <label id="confirmpass_label">{t("confirmPass")}</label>
              <div className="input-group">
                <input
                  type={viewConfirmPass ? "password" : "text"}
                  id="confirmpassword"
                  className="form-control"
                  value={formData.confirmpassword}
                  placeholder="Confirm your password"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  name="confirmpassword"
                  maxLength="64"
                  onChange={onChange}
                />
                <span
                  className="input-group-text"
                  id="viewconfirmpass"
                  onClick={viewConfirmPassword}
                >
                  {!viewConfirmPass && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#7159A5"
                      className="bi bi-eye"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                    </svg>
                  )}
                  {viewConfirmPass && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#7159A5"
                      className="bi bi-eye-slash"
                      viewBox="0 0 16 16"
                    >
                      <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                      <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                      <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                    </svg>
                  )}
                </span>
              </div>
              {validation.confirmPasswordInvalid && (
                <span id="confirmpass_error" className="validationError">
                  {t("passMatchErr")}
                </span>
              )}
            </div>
            {validation.securityErrors && (
              <div className="signup-error">
                <span id="error" className="validationError">
                  {validation.securityErrors}
                </span>
              </div>
            )}
            <div className="fieldset mb-4">
              <button
                type="submit"
                id="next"
                disabled={nextDisable || isSubmitted}
                className={
                  nextDisable || isSubmitted ? "submitBtn dark" : "submitBtn"
                }
                onClick={signValidation}
              >
                {isSubmitted ? (
                  <span>
                    {t("loading")}
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                    ></div>
                  </span>
                ) : (
                  <span>{t("next")}</span>
                )}
              </button>
            </div>
          </div>
          <div className="fieldset text-center" id="copyright-text">
            {t("rightReservedText")}
          </div>
        </div>

        {isSubmitted && <LoadingSpinner />}
      </section>
    </>
  );
};

export default SignUp;
